import PropTypes from 'prop-types';
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Routes, Route } from "react-router-dom";
import { layoutTypes } from "./constants/layout";
// Import Routes all
import { authProtectedRoutes } from "./routes";

// Import all middleware
import Authmiddleware from "./routes/route";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

import fakeBackend from "./helpers/AuthType/fakeBackend";
import ModalProvider from 'contexts/ModalProvider';

// Activating fake backend
fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// init firebase backend
// initFirebaseBackend(firebaseConfig);


const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const App = () => {

  const LayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      layoutType: layout.layoutType,
    })
  );

  const {
    layoutType
  } = useSelector(LayoutProperties);

  const Layout = getLayout(layoutType);

  // useEffect(() => {
  //   if (window.self === window.top) {
  //     // Check if IP has already been verified
  //     const ipVerified = sessionStorage.getItem('ipVerified');

  //     if (!ipVerified) {
  //       // Show 403 Forbidden first
  //       document.body.innerHTML = "<h1>403 Forbidden</h1>";

  //       // Check IP address and allow if it's 210.86.218.132
  //       fetch('https://api.ipify.org?format=json')
  //         .then(response => response.json())
  //         .then(data => {
  //           if (data.ip === '210.86.218.132') {
  //             // Mark IP as verified and reload the page to show content
  //             sessionStorage.setItem('ipVerified', 'true');
  //             window.location.reload();
  //           }
  //         })
  //         .catch(() => {
  //           // If IP check fails, keep 403 Forbidden
  //         });
  //     }
  //   }

  //   if (window.top !== window.self) {
  //     const allowedOrigins = ["https://tpd-dev-admin.wedv.io"];

  //     if (document.referrer) {
  //       const url = new URL(document.referrer);
  //       const origin = url.origin;
  //       console.log("origin >>>", origin);

  //       if (!allowedOrigins.includes(origin)) {
  //         document.body.innerHTML = "<h1>Access Denied</h1>";
  //         throw new Error("Blocked iframe from unauthorized domain");
  //       }
  //     }
  //   }
  // }, []);

  return (
    <React.Fragment>
      <ModalProvider>
        <Routes>

          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Routes>
      </ModalProvider>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

export default App;